<template>
  <div class="ui middle aligned grid h-full" id="login">
    <div class="column login mx-auto">
      <div class="ui segment">
        <div class="ui form">
          <div class="mt-2 mb-10 text-center text-xl text-gray-700 font-bold">
            登录红豆云
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="user icon"></i>
              <input name="login-username" type="text" v-model="username" placeholder="手机号/邮箱" id="username">
            </div>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input name="login-password" type="password" v-model="password" placeholder="登录密码" id="password"
                                                        @keyup.enter="login(username, password)"/>
            </div>
          </div>
          <div class="text-left field">
            <div class="ui toggle checkbox">
              <input id="keep-login" name="keep-login" type="checkbox" tabindex="0" v-model="remember" class="hidden">
              <label>保持登录</label>
            </div>
          </div>
          <button id="login" @click="login" class="ui fluid large teal button">
            登录
          </button>
          <div class="text-right mt-2">
            <a href="javascript:void(0)" @click="register" class="text-blue-500 font-bold">注册</a>
            <a href="javascript:void(0)" @click="forgot_password" class="ml-4 text-gray-600">忘记密码</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: '',
  props: [],
  components: {
  },
  data: function () {
    return {
      username: "",
      password: "",
      remember: false,
    };
  },
  computed: {
  },
  methods: {
    async login() {
      var username = this.username;
      var password = this.password;
      this.$gtag.event('login.attempt');
      try {
        await this.client.login(username, password);
        this.$gtag.event('login.succeeded');
        if (this.remember) {
          this.$store.commit("save_token", this.client.token);
        }
        this.$router.push({ name: 'files' });
      } catch (e) {
        this.show_error("登录失败，请检查输入的信息是否正确");
        this.$gtag.event('login.failed');
      }
    },
    register() {
      this.$gtag.event('login.register');
      this.$router.push({ name: 'register' });
    },
    forgot_password() {
      this.$gtag.event('login.forgot-password');
      this.$router.push({ name: 'reset-password' });
    },
  },
  mounted() {
    this.$(".ui.checkbox").checkbox();
  },
}
</script>

<style>
.column.login {
  max-width: 400px;
}
</style>
